export default __webpack_public_path__ + "static/media/lyftCertificateForNevadaCarsPics.d459aa8f.png";